module.exports = __webpack_public_path__ + "img/banner-portfolio.17dbf35f.jpg";